import React, {createContext, useContext, useReducer} from 'react'
import {VerificationCameraDeviceOverviewReducer} from "../reducer/VerificationCameraDeviceOverviewReducer";
import {PermissionsContext} from "../../../permissions/PermissionsContext";
import PermissionAlertBanner from "../../../commonui/PermissionAlertBanner";

export const VerificationCameraDeviceOverviewContext = createContext();

const VerificationCameraDeviceOverviewContextProvider = (props) => {
    const data = {
        sortPref: {column: "name", direction: "ascending"},
        asmlComponentInformation: {},
        macAddressArray: [],
        loadingOverview: true
    }
    const [viewModel, dispatch] = useReducer(VerificationCameraDeviceOverviewReducer, data)
    const {isAuthorised} = useContext(PermissionsContext);

    if (!isAuthorised){
        return (
            <PermissionAlertBanner/>
        );
    }
    return (
        <VerificationCameraDeviceOverviewContext.Provider value={{viewModel, dispatch}}>
            {props.children}
        </VerificationCameraDeviceOverviewContext.Provider>
    )
}

export default VerificationCameraDeviceOverviewContextProvider



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asmldevice/context/VerificationCameraDeviceOverviewContext.js